import { useEffect } from "react";
import { Link } from "react-router-dom";
import { FiCode, FiArrowLeft, FiDownload } from "react-icons/fi";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";

/**
 * Renders the OpenAPI 3.1 spec for the InceptBench Generator API as an
 * interactive Swagger UI doc. The spec itself is the single source of truth
 * (lives in @trilogy-innovations/content-renderers and is synced into
 * public/openapi.json by the prebuild script). No more handwritten markdown.
 */
const GeneratorApiInterface = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6 lg:px-8">
        {/* Back Link */}
        <Link
          to="/run"
          className="mb-6 inline-flex items-center gap-2 text-sm font-medium text-gray-600 transition-colors hover:text-gray-900"
        >
          <FiArrowLeft className="size-4" />
          Back to Run
        </Link>

        {/* Header */}
        <div className="mb-8">
          <div className="mb-3 flex items-center justify-between gap-3">
            <div className="flex items-center gap-3">
              <div className="flex size-12 items-center justify-center rounded-xl bg-primary-100">
                <FiCode className="size-6 text-primary-600" />
              </div>
              <h1 className="text-3xl font-bold text-gray-900 sm:text-4xl">
                Generator API Interface
              </h1>
            </div>
            <a
              href="/openapi.json"
              download="openapi.json"
              className="inline-flex items-center gap-2 rounded-lg bg-primary-600 px-4 py-2.5 text-sm font-semibold text-white shadow-md transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg"
            >
              <FiDownload className="size-4" />
              Download OpenAPI
            </a>
          </div>
          <p className="text-lg text-gray-600">
            Live OpenAPI 3.1 spec for building content generators compatible
            with InceptBench. Same schema used by runtime validation.
          </p>
        </div>

        {/* Swagger UI */}
        <div className="rounded-xl border border-gray-200 bg-white shadow-sm">
          <SwaggerUI url="/openapi.json" docExpansion="list" />
        </div>
      </div>
    </div>
  );
};

export default GeneratorApiInterface;
